module.exports = __webpack_public_path__ + "img/P40-en.0e81ccf7.png";